import { render } from "./UpdateDateTime.vue?vue&type=template&id=34c84d71"
import script from "./UpdateDateTime.vue?vue&type=script&lang=js"
export * from "./UpdateDateTime.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__